export const ACCREDITED = "accredited";
export const NON_ACCREDITED = "non_accredited";

const normalizeText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const listIncludesRequirement = (value) =>
  Array.isArray(value) &&
  value.some((item) => normalizeText(item) === "requirements");

export const isRequirementCourse = (course = {}) => {
  if (listIncludesRequirement(course.course_types)) return true;
  if (listIncludesRequirement(course.courseTypes)) return true;

  return normalizeText(course.title).endsWith(" requirements");
};

export const getCourseAccreditationAvailability = (course = {}) => {
  if (isRequirementCourse(course)) {
    return {
      accreditedAvailable: false,
      nonAccreditedAvailable: true,
    };
  }

  return {
    accreditedAvailable: course.accredited_available !== false,
    nonAccreditedAvailable: course.non_accredited_available !== false,
  };
};

export const getDefaultAccreditationType = (
  course = {},
  requestedType = ACCREDITED,
) => {
  const { accreditedAvailable, nonAccreditedAvailable } =
    getCourseAccreditationAvailability(course);

  if (!accreditedAvailable) return NON_ACCREDITED;
  if (!nonAccreditedAvailable) return ACCREDITED;
  return requestedType === NON_ACCREDITED ? NON_ACCREDITED : ACCREDITED;
};

export const withCourseAccreditationRule = (course = {}) => {
  if (!isRequirementCourse(course)) return course;

  return {
    ...course,
    accredited_available: false,
    non_accredited_available: true,
  };
};

export const getRequiredPriceValidation = (course = {}) => {
  if (isRequirementCourse(course)) {
    return null;
  }

  return {
    field: "price_inr",
    label: "Accredited INR price",
    message:
      "Valid accredited price (INR) is required (must be 0 or greater)",
  };
};

export const hasValidRequiredPrice = (course = {}) => {
  const requiredPrice = getRequiredPriceValidation(course);
  if (!requiredPrice) return true;

  const { field } = requiredPrice;
  const value = new Map(Object.entries(course)).get(field);
  const numericValue = Number(value);

  return (
    value !== undefined &&
    value !== null &&
    value !== "" &&
    Number.isFinite(numericValue) &&
    numericValue >= 0
  );
};
